import useMetaTag from '@odyssey/hooks/useMetaTag/useMetaTag'

export default function useMetaDescription(description: string) {
  useMetaTag('description', description)
}
